const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/dgjjp8cjv/image/upload';

const toPublicId = (localPath) => {
  const pathWithoutExtension = localPath
    .replace(/^\/+/, '')
    .replace(/\.[^/.]+$/, '');

  return 'exhibirte/' + pathWithoutExtension
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9/_-]+/g, '-');
};

export const cloudinaryAsset = (localPath) => CLOUDINARY_BASE_URL + '/' + toPublicId(localPath);
